import {
  DialogTitle as MuiDialogTitle,
  DialogContent as MuiDialogContent,
  DialogActions as MuiDialogActions,
  Button as MuiButton,
  Dialog as MuiDialog,
} from "@mui/material";

const buttonStyles = {
  height: "40px",
  width: "100px",
};

const StudyRecruitmentDialog = (props) => {
  const {
    onClose,
    open,
    title,
    children,
    okLabel,
    cancelLabel,
    disabledOkButton,
  } = props;

  const handleCancel = () => {
    onClose(false);
  };

  const handleOk = () => {
    onClose(true);
  };

  return (
    <MuiDialog open={open} onClose={handleCancel}>
      <MuiDialogTitle
        id="confirmation-dialog-title"
        sx={{ padding: "16px 24px" }}
      >
        {title}
      </MuiDialogTitle>
      <MuiDialogContent sx={{ padding: "0 24px", overflowY: "visible" }}>
        {children}
      </MuiDialogContent>
      <MuiDialogActions sx={{ padding: "20px 24px 16px", gap: "8px" }}>
        <MuiButton
          variant="outlined"
          onClick={handleCancel}
          color="primary"
          sx={buttonStyles}
        >
          {cancelLabel ? cancelLabel : "Cancel"}
        </MuiButton>
        <MuiButton
          variant="contained"
          disabled={disabledOkButton}
          onClick={handleOk}
          color="primary"
          sx={buttonStyles}
        >
          {okLabel ? okLabel : "OK"}
        </MuiButton>
      </MuiDialogActions>
    </MuiDialog>
  );
};

export default StudyRecruitmentDialog;
